import { ApplicationController } from "../application_controller";

// Compact summary for a Choices multi-select placed inside this controller's element:
// only the first selected item is shown, the rest are collapsed into a "+N" badge,
// and the full list of selected values is shown in a popup on hover (styled in pages/_deals.scss).
export default class extends ApplicationController {
  connect() {
    this.popup = document.createElement("div");
    this.popup.className = "choices-summary__popup";
    this.element.appendChild(this.popup);

    // ignore mutations caused by our own popup updates to avoid an update loop
    this.observer = new MutationObserver(mutations => {
      if (mutations.some(mutation => !this.popup.contains(mutation.target))) this.updateSummary();
    });
    this.observer.observe(this.element, { childList: true, subtree: true });
    this.updateSummary();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
    if (this.popup) this.popup.remove();
  }

  updateSummary() {
    const inner = this.element.querySelector(".choices__inner");
    if (!inner) return;

    const labels = Array.from(this.element.querySelectorAll(".choices__list--multiple .choices__item[data-item]"))
      .map(item => this.itemLabel(item));

    inner.classList.toggle("has-items", labels.length > 0);

    if (labels.length > 1) {
      inner.setAttribute("data-extra-count", "+" + (labels.length - 1));
    } else {
      inner.removeAttribute("data-extra-count");
    }

    this.renderPopup(labels);
  }

  renderPopup(labels) {
    const key = labels.join("\n");
    if (this.popup.dataset.key === key) return;

    this.popup.dataset.key = key;
    this.popup.classList.toggle("has-items", labels.length > 0);
    this.popup.innerHTML = "";
    labels.forEach(label => {
      const row = document.createElement("div");
      row.textContent = label;
      this.popup.appendChild(row);
    });
  }

  // item markup: "<label text><button>Remove item</button>"
  itemLabel(item) {
    return Array.from(item.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent)
      .join("")
      .trim();
  }
}
